import { PrimaryButton } from '@stax-core/truffle-components';
import { FormState } from 'final-form';
import { ButtonHTMLAttributes, FC } from 'react';
import styled from 'styled-components';
import { devices } from '../../util/cssMediaQuery.util';

export interface NextButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** This serves as the 'id', 'data-testid', and 'trackingId' */
  id: string;
  formProps: FormState<any, any>;
  /** Override for button text, default is 'Next' */
  text?: string;
  [key: string]: any;
}

const BottomButtons = styled.div`
  margin-top: 1em;
  padding-bottom: 4px;
  align-self: end;
  ${devices.tablet} {
    align-self: auto;
  }
`;

export const NextButton: FC<NextButtonProps> = props => {
  const { formProps, text, id, ...rest } = props;

  return (
    <BottomButtons>
      <PrimaryButton
        style={{ width: '100%' }}
        type="submit"
        id={id}
        data-testid={id}
        trackingId={id}
        loading={formProps?.submitting}
        disabled={
          !formProps || formProps?.submitting || formProps?.hasValidationErrors
        }
        {...rest}
      >
        {formProps?.submitting ? 'Saving...' : text || 'Next'}
      </PrimaryButton>
    </BottomButtons>
  );
};
